<script>
import resources from './resources'

export default {
  name: 'professional-graduations-form',
  mixins: [resources]
}
</script>

<template lang="pug">
page(title="Minhas Graduações", icon="")
  .col-xs-12.content
    .container-fluid
      .row
        .nav-tabs-wrapper
          ul.nav.nav-tabs.nav-340
            li
              router-link(:to="{name: 'professional.curriculum.graduations.index'}")
                a(href="#") Listagem
            li.active
              a(href='#') Cadastro
        .col-xs-12.white-bg
          .row
            .col-xs-12
              form.col-sm-10
                label(style='margin-top:30px;') Profissional
                br
                h4
                  label(for='profissional') {{ professional.name }} (CRM — {{ professional.document }}/{{ professional.state }})
                .form-group.border-top
                  v-input(:status="$v.graduation.label.$error ? 'error' : null")
                    f-text(
                      label="Graduação (nome do curso)"
                      name="label",
                      v-model="graduation.label",
                      :errors="errors['label']")

                .form-group
                  .row
                    .col-xs-12.col-sm-8.margin-bottom
                      v-input(:status="$v.graduation.entity.$error ? 'error' : null")
                        f-text(label="Entidade de Ensino"
                          name="entity",
                          v-model="graduation.entity",
                          :errors="errors['entity']")

                    .col-xs-12.col-sm-4.margin-bottom
                      v-input(:status="$v.graduation.year.$error ? 'error' : null")
                          label Ano de Graduação
                            v-picker-months(
                              v-model="graduation.year",
                              name="start",
                              placeholder="aaaa",
                              :configMonths='configMonths')


                  //-- Removido devido a novo modulo de aquivos
                  //--.row
                    .col-xs-12
                      f-file-text(v-if="!graduation.attachment.uuid", label="Anexar comprovante"
                       v-model="graduation.attachment",
                       name='attachment',
                       :errors="errors['attachment'] || errors['attachment.file'] || errors['attachment.mime']")

                .buttons-wrapper
                  button.btn.save(@click.prevent="doSave()")
                    span.icon 
                    |  Salvar Alterações
</template>



// WEBPACK FOOTER //
// src/app/professional/curriculum/graduations/form/form.vue